import moment from "moment"

export default {
	getters: {
		compareValues() {
			return (key, order = "asc", convertToType = null) => {
				return function innerSort(a, b) {
					if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key))
						return 0

					var varA = a[key]
					var varB = b[key]

					if (typeof a[key] === "string") {
						varA = a[key].toUpperCase()
						varB = b[key].toUpperCase()
					}

					if (convertToType !== null && typeof convertToType === "function") {
						varA = convertToType(a[key])
						varB = convertToType(b[key])
					}

					var comparison = 0

					if (varA > varB) {
						comparison = 1
					}
					else if (varA < varB) {
						comparison = -1
					}

					return order === "desc" ? (comparison * -1) : comparison
				}
			}
		},
		getShortDuration() {
			return (from, to, checkFromNow) => {
				var duration = ""

				if (from == to && checkFromNow) {
					var difference = moment().diff(moment(from, "DD-MM-YYYY HH:mm:ss"))

					duration = moment.duration(difference).format("D[D] H[H] m[M]")
				}
				else {
					var difference = moment(to, "DD-MM-YYYY HH:mm:ss").diff(moment(from, "DD-MM-YYYY HH:mm:ss"))

					duration = moment.duration(difference).format("D[D] H[H] m[M]")
				}

				return duration
			}
		},
		getDuration() {
			return (from, to) => {
				var duration = ""

				if (from == to) {
					var difference = moment().diff(moment(from, "DD-MM-YYYY HH:mm:ss"))

					duration = moment.duration(difference).format("D[D] H[H] m[M]", { forceLength: true, trim: false })
				}
				else {
					var difference = moment(to, "DD-MM-YYYY HH:mm:ss").diff(moment(from, "DD-MM-YYYY HH:mm:ss"))

					duration = moment.duration(difference).format("D[D] H[H] m[M]", { forceLength: true, trim: false })
				}

				return duration
			}
		},
		getDurationFormatted() {
			return (from, to) => {
				var duration = ""

				if (from == to) {
					var difference = moment().diff(moment(from, "DD-MM-YYYY HH:mm:ss"))

					duration = moment.duration(difference).format("D[<i>D</i>] H[<i>H</i>] m[<i>M</i>]", { forceLength: true, trim: false })
				}
				else {
					var difference = moment(to, "DD-MM-YYYY HH:mm:ss").diff(moment(from, "DD-MM-YYYY HH:mm:ss"))

					duration = moment.duration(difference).format("D[<i>D</i>] H[<i>H</i>] m[<i>M</i>]", { forceLength: true, trim: false })
				}

				return duration
			}
		}
	},

	namespaced: true
}